import { useEffect, useRef, useState } from "react"

export function AnimatedNumber({ value, locale = "en" }: { value: number; locale?: string }) {
  const ref = useRef<HTMLSpanElement>(null)
  const [display, setDisplay] = useState(value)

  useEffect(() => {
    const element = ref.current

    if (
      !element ||
      !("IntersectionObserver" in window) ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      setDisplay(value)

      return
    }

    setDisplay(0)
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) {
          return
        }

        observer.disconnect()
        const started = performance.now()
        const duration = 1500
        const tick = (now: number) => {
          const progress = Math.min((now - started) / duration, 1)
          const eased = 1 - (1 - progress) ** 4
          setDisplay(Math.round(value * eased))

          if (progress < 1) {
            window.requestAnimationFrame(tick)
          }
        }
        window.requestAnimationFrame(tick)
      },
      { threshold: 0.4 },
    )
    observer.observe(element)

    return () => observer.disconnect()
  }, [value])

  return <span ref={ref}>{new Intl.NumberFormat(locale).format(display)}</span>
}
